import React, { Component } from "react";
import { NavLink, Link, withRouter } from "react-router-dom";
import { avater, logo } from "../../../utils/Constants";
import {
  home,
  contact,
  price,
  featuredCourse,
  myCourses,
  progressReport,
  userProfile,
} from "../../../utils/routes";
import { Dropdown, Navbar, Nav } from "react-bootstrap";
import Bdt1 from "../../../assets/static/svg/bdt1.svg";
import Logout from "../../../assets/static/svg/logout.svg";
import ProgressReport from "../../../assets/static/svg/progressReport.svg";
import AllTakenCourse from "../../../assets/static/svg/allTakenCourse.svg";
import { ReactSVG } from "react-svg";
import {
  loadState,
  removeStoreById,
  saveState,
} from "../../../LocalStore/localStorage";
import { connect } from "react-redux";
import { getStudentInfo, studentLogin } from "../../../redux/actions/auth";
import { withTranslation } from "react-i18next";
import LoginModal from "../../modal/loginModal";
import LoginPage from "../../modal/loginPage";
import { setLocalization } from "../../../redux/actions/localization";
import defaultImgSetup from "../../../redux/helper/defaultImgSetup";
import { getPhoneNumber, getSubInfo } from "../../../redux/actions/subInfo";
import http from "../../../redux/apis/service"

export class Header extends Component {
  state = {
    position: 0,
    studentId: loadState("uuid"),
    msisdn: loadState("msisdn"),
    token: loadState("token"),
    lng: "bn",
  };

  async componentDidMount() {
    const { userInfo } = this.props;
    const { studentId, msisdn } = this.state;

    await this.props.dispatch(setLocalization("en"));
    await this.props.dispatch(getPhoneNumber());

    if (this.props.getMsisdn?.user_info) {
      const msisdn = this.props.getMsisdn.user_info.msisdn;

      await saveState("msisdn", msisdn);
      await this.props.dispatch(studentLogin(msisdn));

      if (this.props.userInfo) {
        await saveState("uuid", this.props.userInfo.student_id);
        await this.props.dispatch(
          getStudentInfo(this.props.userInfo.student_id),
        );
        await this.props.dispatch(getSubInfo(msisdn));

        this.setState({
          msisdn,
          studentId: this.props.userInfo.student_id,
        });
      }
    }

    if (studentId && userInfo.length < 1) {
      await this.props.dispatch(getStudentInfo(studentId));
      await this.props.dispatch(getSubInfo(msisdn));
    }

    window.addEventListener("scroll", this.listenToScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.listenToScroll);
  }

  listenToScroll = () => {
    this.setState({ position: window.scrollY });
  };

  logout = async () => {
    try {
      const response = await http.getV3(`log-out`);

      await removeStoreById("uuid");
      await removeStoreById("msisdn");
      await removeStoreById("token");
      window.location.reload();
    } catch (e) {
      console.error("Logout error", e);
    }
  };

  changeLanguage = async (lng) => {
    const newLng = lng === "en" ? "bn" : "en";
    this.setState({ lng: newLng });
    await this.props.dispatch(setLocalization(newLng));
    await this.props.i18n.changeLanguage(newLng);
  };

  render() {
    const { position, studentId, lng, token } = this.state;
    const { userInfo, t, getMsisdn, location } = this.props;
    const { data } = getMsisdn;

    const isSehriNotificationRoute =
      location.pathname.startsWith("/sehri-notification") ||
      window.location.search.includes("msisdn=");

    const isLiveStreamingRoute =
      location.pathname.startsWith("/live-streaming");

    const hideLoginRoutes = ["/home", "/sehri-iftar-time", "/live-streaming"];

    // const shouldShowLogin =
    //   !isLiveStreamingRoute &&
    //   !isSehriNotificationRoute &&
    //   !studentId &&
    //   data &&
    //   data.errors &&
    //   !hideLoginRoutes.includes(location.pathname);

    const shouldShowLogin =
      !isLiveStreamingRoute &&
      !isSehriNotificationRoute &&
      !token &&
      !hideLoginRoutes.includes(location.pathname);

    return (
      <header
        className={position > 150 ? "header headerSticky" : "header"}
        id="header"
      >
        <div className="container">
          <Navbar expand="lg">
            <Link to={home} className="logo">
              <img src={logo} alt="logo" />
            </Link>

            <Navbar.Toggle aria-controls="mainMenu">
              <span className="bar" />
              <span className="bar" />
              <span className="bar" />
            </Navbar.Toggle>

            <Navbar.Collapse id="mainMenu" className="mainMenu">
              <Nav className="ml-auto">
                <li className="nav-item">
                  <NavLink to={home} className="nav-link">
                    {t("home")}
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to={featuredCourse} className="nav-link">
                    {t("featuredCourses")}
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink to={price} className="nav-link">
                    {t("pricing")}
                  </NavLink>
                </li>

                {studentId && (
                  <li className="nav-item">
                    <NavLink to={myCourses} className="nav-link">
                      {t("myCourse")}
                    </NavLink>
                  </li>
                )}

                <li className="nav-item">
                  <NavLink to={contact} className="nav-link">
                    {t("contact")}
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    to="#"
                    className="nav-link joinBtn"
                    onClick={() => this.changeLanguage(lng)}
                  >
                    {t("ln")}
                  </NavLink>
                </li>

                {shouldShowLogin && (
                  <li className="nav-item">
                    <LoginModal />
                  </li>
                )}

                {!studentId && shouldShowLogin && (
                  <li className="nav-item">
                    <LoginPage />
                  </li>
                )}

                {studentId && userInfo && (
                  <li className="nav-item">
                    <Dropdown className="afterLogin">
                      <Dropdown.Toggle id="dropdown-basic">
                        <img
                          src={defaultImgSetup(userInfo.profile_pic)}
                          alt="avatar"
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Link to={userProfile} className="userProfile">
                          <h6>
                            {userInfo.first_name}{" "}
                            {userInfo.last_name || "Update Profile"}
                          </h6>
                        </Link>

                        <Link to={myCourses}>All Taken Course</Link>
                        <Link to={progressReport}>Progress Report</Link>
                        <Link to="#" onClick={this.logout}>
                          Log out
                        </Link>
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                )}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
  localization: state.localizationReducer,
  getSubInfo: state.getSubInfo,
  getMsisdn: state.getMsisdn,
});

export default withTranslation()(connect(mapStateToProps)(withRouter(Header)));
